import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsPage } from "../../pages/dashboard/integrations/Integrations.page";

export const Route = createFileRoute("/_protected/dashboard/integrations")({
  component: IntegrationsPage,
});
